<div class="row g-3">
  <div class="col col-12">
    <h4 class="display-4">
      {{ 'business_plans' | translate }}
    </h4>

    <hr class="m-0" />
  </div>

  <div class="col col-12">
    <div
      class="row g-3"
      [tds-data-loader]="{
        key: 'device-plans',
        class: 'col w-100 py-4',
        size: 'lg'
      }"
    >
      <div *ngFor="let plan of business_plans; let i = index" class="col col-12">
        <div
          as-button
          class="card"
          [class.active-card]="plan.id == plan_id"
          [class.elevate]="plan.id != plan_id"
          [attr.aria-label]="plan"
          (click)="selectPlan(plan)"
        >
          <div class="card-body">
            <div class="row d-flex justify-content-between">
              <div class="col">
                <img
                  class="img-fluid"
                  [src]="plan?.carrier?.image_url"
                  [alt]="plan?.carrier?.name"
                />

                <h5 class="mt-2 line-clamp-2">
                  {{ plan.name_override ? plan.name_override : plan.name }}
                </h5>

                <small>
                  <button
                    stop-click-propagation
                    *ngIf="sanitizedHTML(plan.full_description)"
                    class="btn btn-link neutral-btn text-capitalize fw-light text-decoration-underline px-1 ms-n1 focus-visible"
                    (click)="
                      openDetailsModal(
                        plan,
                        plan.description
                          ? plan.full_description + ' ' + plan.description
                          : plan.full_description
                      )
                    "
                  >
                    {{ 'view_details' | translate }}
                  </button>
                </small>
              </div>

              <div class="col col-auto text-end d-flex">
                <span *ngIf="plan.cost_to_currency">
                  <h5 class="my-0">{{ plan.cost_to_currency }}</h5>

                  <small class="text-secondary d-block">
                    {{ 'per_month' | translate }}
                  </small>
                </span>
              </div>
            </div>
          </div>

          <ts-admin-override-badge
            *ngIf="plan.admin"
            class="position-absolute bottom-0 end-0 border-top-left-radius"
          />
        </div>
      </div>

      <div *ngIf="no_plans" class="col col-12">
        <div class="alert alert-danger" role="alert">
          {{ 'business_plans_no_results' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
